/** Config key of the Devware metadata form the layout switch drives. */
export const QUESTION_FORM_CONFIG_KEY = 'Question';
/** Config key the layout switch registers under so it gets its own gear panel entry. */
export const QUESTION_FORM_LAYOUT_WIDGET_KEY = 'Question-layout';

export interface QuestionFormLayoutVariant {
  key: 'redesign' | 'original';
  label: string;
  description: string;
  /** Asset holding the full form ConfigJson; only `.section` is used. */
  asset: string;
}

export const QUESTION_FORM_LAYOUT_VARIANTS: QuestionFormLayoutVariant[] = [
  {
    key: 'redesign',
    label: 'Redesign',
    description: 'Question and Answers cards with a details aside',
    asset: 'assets/config/question-form.redesign.json'
  },
  {
    key: 'original',
    label: 'Original',
    description: 'Single stacked Question card',
    asset: 'assets/config/question-form.original.json'
  }
];
